import { NextRouter } from 'next/router';

import { logout, updateAuthInStorage } from './auth';
import { fixUrlForCloudFront } from './cloudfront';
import { getExternalServiceUrl } from './environment';
import { postJson } from './fetchOptions';
import { redirectClientToOmniIfNeeded } from './redirectOmni';
import { synchronizeLanguage, hasUrlLanguagePrefix } from './languages';

export const checkToken = async (
  router: NextRouter,
  redirectLink: string,
  jwt: string | string[]
) => {
  try {
    const response = await postJson({
      url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/authenticate/with-token`,
      body: { token: jwt.toString() }
    });

    if ('token' in response && 'user' in response) {
      const { token: jwtToken, user, code } = response;

      updateAuthInStorage({
        token: jwtToken,
        user,
        code
      });

      // Set the app's language to the user's language preference if no URL language prefix
      if (!hasUrlLanguagePrefix() && user.user?.language) {
        synchronizeLanguage(user.user.language, 'jwt-authentication');
      }

      // Redirect influencers to collab app (all environments)
      if (user.is_influencer) {
        const collabBaseUrl = getExternalServiceUrl('collab');
        const separator = redirectLink.includes('?') ? '&' : '?';
        const collabUrl = `${collabBaseUrl}${redirectLink}${separator}jwt=${jwtToken}`;
        setTimeout(() => {
          window.location.href = collabUrl;
        }, 100);
        return;
      }

      if (redirectClientToOmniIfNeeded(user)) {
        return;
      }

      // Redirect to the target URL
      setTimeout(() => {
        window.location.href = fixUrlForCloudFront(redirectLink);
      }, 100);
    } else {
      logout();
    }
  } catch (error) {
    console.error('JWT authentication failed:', error);
    logout();
  }
};
